import { Component } from '@angular/core';

import { BreakpointService } from '@library/core/services';

@Component({
   selector: 'lib-loading',
   template: `
      <div *ngIf="breakpoints.small">
         <mat-spinner diameter="30" class="common-m1emauto"></mat-spinner>
      </div>

      <div *ngIf="!breakpoints.small">
         <mat-progress-bar mode="indeterminate"></mat-progress-bar>
      </div>
   `,
})
export class LoadingComponent {
   constructor( public breakpoints: BreakpointService ) {}
}
